<template>
  <TextInput
    ref="textInputRef"
    v-model="localString"
    :placeholder="placeholder"
    :inputClasses="inputClasses"
    :classes="classes"
  />
</template>

<script setup lang="ts">
import { onKeyStroke } from '@vueuse/core'
import { onMounted, ref, toRefs, watch } from 'vue'

import TextInput from '@/common/components/molecules/TextInput.vue'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (event: 'update:modelValue', value: string): void
}>()
const props = withDefaults(
  defineProps<{
    modelValue?: string
    placeholder?: string
    inputClasses?: string
    classes?: string
  }>(),
  {
    modelValue: '',
    placeholder: '',
    inputClasses: '',
    classes: '',
  },
)
const { modelValue } = toRefs(props)

const textInputRef = ref<HTMLInputElement | null>(null)
function getInputElement() {
  if (!textInputRef.value) return null
  // @ts-ignore
  return textInputRef.value.$el.querySelector('input')
}
const localString = ref('')
onMounted(() => getInputElement()?.focus())
onKeyStroke('Escape', () => getInputElement()?.blur())
onKeyStroke('k', event => {
  if (event.ctrlKey || event.metaKey) {
    event.preventDefault()
    getInputElement()?.focus()
  }
})

onMounted(() => {
  if (!modelValue.value) return
  localString.value = modelValue.value
})
watch(modelValue, () => {
  localString.value = modelValue.value ?? ''
})
watch(localString, () => {
  if (localString.value === modelValue.value) return
  emit('update:modelValue', localString.value)
})
</script>
